import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { searchRequested } from '../../../redux/search';
import colors from '../../../styling/colors';
import { Tabs, Tab } from './SearchComponents/Tabs';
import Form from './SearchComponents/Form';
import Categories from './SearchComponents/Categories';
import Close from '../../../assets/svg/Close';
import BlankButton from '../Buttons/BlankButton';
import { BaseModalContainer } from './ModalContainers/ModalContainers';
import { withRouter } from 'next/router';

const FEATURED_CATEGORIES_QUERY = gql`
  {
    featuredNavNodes {
      color
      customUrl
      desktopDefaultCrossSellingTab
      desktopFlyerCategories
      id
      mobileDefaultCrossSellingTab
      mobileFlyerCategories
      slug
      title: fullTitle
      type
    }
  }
`;

const Container = styled(BaseModalContainer)`
  height: 100%;
  overflow-y: auto;
`;

const SearchHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 3.5rem;
  align-items: center;
  border-bottom: solid 1px ${colors('gallery')};
`;

const ButtonWithPadding = styled(BlankButton)`
  padding: 0 1rem;
`;

export const Search = ({
  categorySearchPath,
  categorySearchTitle,
  isEligibleForCategorySearch,
  closeAction,
  onSubmit,
  searchId,
  router: {
    query: { q: searchQuery },
  },
}) => {
  const [isCategorySearchActive, setIsCategorySearchActive] = useState(true);
  const isCategorySearch =
    isCategorySearchActive && isEligibleForCategorySearch;

  const handleTabChange = index => {
    setIsCategorySearchActive(index === 0);
  };

  const onTextInputSubmit = query => {
    if (isCategorySearch) {
      onSubmit(query, 'category', categorySearchPath);
    } else {
      onSubmit(query, searchId, undefined);
    }
  };

  const placeholder = isCategorySearch
    ? `Search in ${categorySearchTitle}`
    : 'Search in all categories';

  const { loading, error, data = {} } = useQuery(FEATURED_CATEGORIES_QUERY);

  if (error || loading) {
    return null;
  }

  return (
    <Container>
      <SearchHeader>
        <Form
          onFormSubmit={onTextInputSubmit}
          placeholder={placeholder}
          defaultValue={searchQuery}
        />
        <ButtonWithPadding onClick={closeAction}>
          <Close />
        </ButtonWithPadding>
      </SearchHeader>
      {isEligibleForCategorySearch ? (
        <Tabs onChange={handleTabChange}>
          <Tab title={categorySearchTitle} />
          <Tab title="All Categories">
            <Categories featuredCategories={data.featuredNavNodes} />
          </Tab>
        </Tabs>
      ) : (
        <Categories featuredCategories={data.featuredNavNodes} />
      )}
    </Container>
  );
};

Search.propTypes = {
  categorySearchPath: PropTypes.string,
  categorySearchTitle: PropTypes.string,
  isEligibleForCategorySearch: PropTypes.bool,
  closeAction: PropTypes.func,
  onSubmit: PropTypes.func,
  searchId: PropTypes.string,
};

Search.defaultProps = {
  searchId: 'main',
};

const mapStateToProps = ({}) => ({
  isEligibleForCategorySearch: false,
  categorySearchTitle: 'SEARCH title',
  categorySearchPath: 'category/test',
});

const mapDispatchToProps = {
  onSubmit: searchRequested,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Search));
